import {
  WEEKLY_CHECK_IN_ADMIN_MERCHANDISING_CONTENT,
  WEEKLY_CHECK_IN_IC_MERCHANDISING_CONTENT,
  WEEKLY_CHECK_IN_MANAGER_MERCHANDISING_CONTENT,
} from "./constant";

export const getWeeklyCheckInMerchandisingContent = (type: string) => {
  switch (type) {
    case "admin":
      return WEEKLY_CHECK_IN_ADMIN_MERCHANDISING_CONTENT;
    case "manager":
      return WEEKLY_CHECK_IN_MANAGER_MERCHANDISING_CONTENT;
    case "individual-contributor":
    default:
      return WEEKLY_CHECK_IN_IC_MERCHANDISING_CONTENT;
  }
};
